// namespace
window.Components = window.Components || {};

import domReady from '@wordpress/dom-ready';

(function($) {

  'use strict';

  function ajaxForm() {

    const self = this,
        $cache = {};
    let url = false,
        isProcessing = false;

    /**
     * Display message
     *
     * @param  {boolean} valid   Whether the submission succeeded
     * @param  {string}  message Message to display
     */
    function displayMessage(valid, message) {
      message = message || false;
      if(valid) {
        //Redirect immediately, no success message needed
        const redirectLink = $cache.form.data('redirect');
        window.location.href = redirectLink;

      } else {
        //Error Message
        $cache.messageError.html($cache.messageError.data('message'));
        if(message) $cache.messageError.html(message);

        $cache.formMessage.addClass('error');
      }
    }

    /**
     * Hide message
     */
    function hideMessage() {
      $cache.formMessage.removeClass('error valid');
    }

    function initRecaptcha() {
        refreshRecaptcha();
        console.log('initRecaptcha');

        setInterval(function() {
          refreshRecaptcha();
        }, 120000);
    }

    function refreshRecaptcha() {
        /* eslint-disable no-undef */
        grecaptcha.ready(function () {
            grecaptcha.execute(recaptchaSiteKey, { action: 'contact' }).then(function(token) {
                $cache.main.find('input[name="recaptcha_response"]').val(token);
            });
        });
        /* eslint-enable no-undef */
    }

    /**
     * Submit form
     *
     * @param  {Event} event Native form submit event
     */
    function submitForm(event) {
      event.preventDefault();

      if(isProcessing) return;
      isProcessing = true;

      //Clear old message
      hideMessage();

      // Update form fields
      $cache.formFields = $cache.form.find('input:not([type="submit"]), textarea');

      //Clear old submitted values
      self.formData = new FormData();

      $cache.formFields.each(function(){
        const $el = $(this);

        // console.log( $el.attr('name') );

        if( $el.attr('name') === 'file'){
          const $file = document.getElementById('file').files;
          self.formData.append('file', $file[0]);
          // self.formData.append($el.attr('files')[0], $el.val());
        } else if ($el.attr('name') !== 'file[]') {
          self.formData.append($el.attr('name'), $el.val());
        }
      });

      const files = $cache.form.find('input[name="file[]"]');
      if (files.length > 0) {
          for (let index = 0; index < files.length; index++) {
              self.formData.append("file[]", files[index].files[0]);
          }
      }

      $.ajax({
          method: 'POST',
          url, // check the exact URL for your situation
          dataType: 'JSON',
          cache: false,
          contentType: false,
          processData: false,
          data: self.formData,
          success(data) {
              // Display message
              displayMessage(data.success, data.message);

              // Reset recaptcha
              // grecaptcha.reset();
              refreshRecaptcha();

              // Release Submit
              isProcessing = false;
          },
          error(errorThrown) {
              console.log("Error");
              console.log(errorThrown);

              // Display message
              displayMessage(false, null);

              // Reset recaptcha
              refreshRecaptcha();
              // grecaptcha.reset();

              // Release Submit
              isProcessing = false;

              return false;
          }
      });       
    }
    
    /**
     * Init Cache
     *
     * @param  {Object} target jQuery-wrapped root element
     */
    function initCache(target) {
      $cache.main = target;
      $cache.form = $cache.main.find('form');
      $cache.formFields = $cache.form.find('input:not([type="submit"]), textarea');
      $cache.formMessage = $cache.form.find('.form-message');
      $cache.messageValid = $cache.formMessage.find('.valid');
      $cache.messageError = $cache.formMessage.find('.error');

      
    }

    /**
     * Register Events
     */
    function registerEvents() {
    }


    /**
     * Public constructor
     *
     * @param  {Object} target jQuery-wrapped root element
     */
    self.initialize = function(target) {
      initCache(target);

      url = $cache.main.data('url');

      registerEvents();

      initRecaptcha();

      $cache.form.on('submit', submitForm);
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.ajaxForm = ajaxForm;

  domReady(() => {
    $('[data-component="ajaxForm"]').each(function() {
      new window.Components.ajaxForm($(this));
    });
  });

}(jQuery));